module.exports = __webpack_public_path__ + "static/media/logo-lagoverde.cc8e3f25.png";